// Actions
export const setLinksExternos = ({ commit }, payload) => {
  commit('SET_LINKS_EXTERNOS', payload)
}
export const addLinksExternos = ({ commit }, payload) => {
  commit('ADD_LINKS_EXTERNOS', payload)
}
export const setLinksExternosLoading = ({ commit }, payload) => {
  commit('SET_LINKS_EXTERNOS_LOADING', payload)
}

